export default "/assets/images/peacekeeper-1.png?4af8ad42237b519ddc001f700f8bd817";